import router from '../router/router'

const state = {
    filterData: { 
        data_inicio: null, 
        data_final: null,
        operadora_ans_id: null,
        periodo: null,
        status: null, 
    },
    listOperadora: [],
    operadoras: [],
    monitoringList: [],
}
const mutations = {
    resetFilter(state) {
        state.filterData = { 
            data_inicio: null, 
            data_final: null,
            operadora_ans_id: null,
            periodo: null,
            status: null
        }
    },
    updateOperadoras:(state, list) => {
        state.listOperadora = list? list.reduce((obj, oper) => {
            obj[oper.id] = oper.oper_nome
            return obj
         },{}) : []
    }
}
const actions = {
    setFilter({state}, obj) {
        state.filterData.status = obj.status? obj.status.seriesId : null
        state.filterData.data_inicio = obj.data_inicio ? obj.data_inicio : null
        state.filterData.data_final = obj.data_final ? obj.data_final : null
        state.filterData.periodo = obj.periodo ? obj.periodo : null
        state.filterData.operadora_ans_id = obj.operadora_ans_id ? obj.operadora_ans_id : []
        state.filterData.prestador_id = obj.prestador_id ? obj.prestador_id : []
        router.push(obj.rota)
    },
    async getMonitoramento( {state}, opts ) {
        let geco = opts.grupoEconomico? opts.grupoEconomico : this.state.permissions.grupoEconomico
        let obj = {
            url: '/api/proxy/postdata', 
            query: [
              {
                Modulo: "Autorizador",
                Acao: "getmonitoramento",
                Payload: {
                    grupo_economico: geco,
                    periodo: opts.periodo? opts.periodo : 'dia',
                    ...opts
                },
              },
            ],
        };
        let resp = await this.dispatch("request/doRequest", obj).then(response => {
            state.monitoringList = response.dados
            return response
        });
        return resp
    } 
} 
export default {
    namespaced: true,
    root: true,
    actions,
    mutations,
    state,
};